import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const InternationalMain = lazy(
  () => import('../international/InternationalMain')
);
const DrugTestRequests = lazy(
  () => import('../international/DrugTestRequests/DrugTestRequests')
);
const L2Reg = lazy(() => import('../international/L2Reg/L2Reg'));
const WlpClubComm = lazy(() => import('../international/WlpClubComm'));
const L1Reg = lazy(() => import('../international/l1Reg/L1Reg'));

export default [
  {
    id: NavConfig.groupConfigs.INTERNATIONAL.id,
    path: NavConfig.groupConfigs.INTERNATIONAL.to,
    element: (
      <InternationalMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </InternationalMain>
    ),

    children: [
      {
        index: true,
        element: (
          <Navigate to={NavConfig.linkConfigs.INT_DRUG_TEST_REQUESTS.to} />
        ),
      },
      {
        id: NavConfig.linkConfigs.INT_WLP_CLUB_COMMS.id,
        path: NavConfig.linkConfigs.INT_WLP_CLUB_COMMS.to,
        element: <WlpClubComm />,
      },
      {
        id: NavConfig.linkConfigs.INT_DRUG_TEST_REQUESTS.id,
        path: NavConfig.linkConfigs.INT_DRUG_TEST_REQUESTS.to,
        element: <DrugTestRequests />,
      },
      {
        id: NavConfig.linkConfigs.INT_L1_REG.id,
        path: NavConfig.linkConfigs.INT_L1_REG.to,
        element: <L1Reg />,
      },
      {
        id: NavConfig.linkConfigs.INT_L2_REG.id,
        path: NavConfig.linkConfigs.INT_L2_REG.to,
        element: <L2Reg />,
      },
    ],
  },
];
